module.exports = __webpack_public_path__ + "static/img/coupon4.dbd920f3.png";